<template>
  <div class="overflow-scroll-table">
    <table class="responsive-table">
      <thead>
        <tr v-if="columnSet === 'appointments'">
          <th />
          <th colspan="5">Requests</th>
          <th colspan="2">Sessions</th>
          <th />
        </tr>
        <tr>
          <th
            v-for="col in columnSets[columnSet].columns"
            :key="col.id"
            @click="onSort(col.sortTokens, col.id)"
          >
            {{ col.display_label }}
            <font-awesome-icon v-if="col.sortTokens[0] !== null" :icon="['fas', 'sort']" class="icon alt" />
            <span
              v-if="col.id === sortedColumn"
              :class="sortedAsc ? 'active-up' : 'active-down'"
            >
              <font-awesome-icon
                :icon="['fas', 'sort-down']"
                class="icon alt"
              />
              <font-awesome-icon :icon="['fas', 'sort-up']" class="icon alt" />
            </span>
          </th>

          <th />
        </tr>
      </thead>
      <tbody v-if="columnSet === 'overview'">
        <tr v-for="row in counselors" :key="row.id">
          <td>
            {{ row.firstName + ' ' + row.lastName }}
            <label class="d-block d-md-none"> Counselor Name: </label>
          </td>

          <td>
            {{ row.email }}
            <label class="d-block d-md-none"> Email: </label>
          </td>

          <td>
            {{
              row.registeredStates.length > 0
                ? row.registeredStates.join(', ')
                : 'N/A'
            }}
            <label class="d-block d-md-none"> Registered In: </label>
          </td>

          <td>
            {{ row.verified ? 'Yes' : 'No' }}
            <label class="d-block d-md-none"> Verified: </label>
          </td>
          <td>
            {{ row.isActive ? 'Yes' : 'No' }}
            <label class="d-block d-md-none"> Active: </label>
          </td>
          <td>
            {{ row.hasSetWorkingHours ? 'Yes' : 'No' }}
            <label class="d-block d-md-none"> Working Hours Set: </label>
          </td>

          <td>
            {{ row.dateJoined | dateOnly }}
            <label class="d-block d-md-none"> Date Joined: </label>
          </td>

          <td>
            <span v-if="row.lastLogin">{{ row.lastLogin | dateOnly }}</span>
            <span v-else>N/A</span>
            <label class="d-block d-md-none"> Last Login: </label>
          </td>

          <td class="icons">
            <button
              v-b-tooltip.hover.top="'Impersonate User'"
              type="button"
              class="fa-btn"
              title="View as User"
              @click="$emit('impersonate', row.userId)"
            >
              <font-awesome-icon
                :icon="['fas', 'user-secret']"
                class="icon alt"
              />
            </button>

            <button
              v-if="row.calendarInitialized"
              v-b-tooltip.hover.top="'View Availability'"
              type="button"
              class="fa-btn"
              title="View Availability"
              @click.left.exact="viewAvailability(row)"
              @dblclick.left.alt.exact="viewAvailability(row, 'agenda')"
            >
              <font-awesome-icon :icon="['fas', 'calendar']" class="icon alt" />
            </button>

            <button
              v-b-tooltip.hover.top="'Send Message'"
              type="button"
              class="fa-btn"
              title="Send Message"
              @click="sendMessage({ counselor: row })"
            >
              <font-awesome-icon :icon="['fas', 'envelope']" class="icon alt" />
            </button>

            <button
              v-b-tooltip.hover.top="'View Counselor Details'"
              type="button"
              class="fa-btn"
              title="View Counselor Details"
              @click="viewCounselor(row)"
            >
              <font-awesome-icon :icon="['fas', 'file-alt']" class="icon alt" />
            </button>
          </td>
        </tr>
      </tbody>
      <tbody v-if="columnSet === 'appointments'">
        <tr v-for="row in counselors" :key="row.id">
          <td>
            {{ row.firstName + ' ' + row.lastName }}
            <label class="d-block d-md-none"> Counselor Name: </label>
          </td>

          <td>
            {{ row.requests.pending | number }}
            <label class="d-block d-md-none"> Pending Requests: </label>
          </td>

          <td>
            {{ row.requests.approved | number }}
            <label class="d-block d-md-none"> Approved Requests: </label>
          </td>

          <td>
            {{ row.requests.declined | number }}
            <label class="d-block d-md-none"> Declined Requests: </label>
          </td>

          <td>
            {{ row.requests.canceled | number }}
            <label class="d-block d-md-none"> Canceled Requests: </label>
          </td>

          <td>
            {{ row.requests.expired | number }}
            <label class="d-block d-md-none"> Expired Requests: </label>
          </td>

          <td>
            {{ row.sessions.canceled | number }}
            <label class="d-block d-md-none"> Canceled Sessions: </label>
          </td>

          <td>
            {{ row.sessions.canceledByCounselor | number }}
            <label class="d-block d-md-none">
              Canceled by Counselor Sessions:
            </label>
          </td>

          <td class="icons">
            <button
              v-if="row.lastLogin"
              v-b-tooltip.hover.top="'Impersonate User'"
              type="button"
              class="fa-btn"
              title="View as User"
              @click="$emit('impersonate', row.userId)"
            >
              <font-awesome-icon
                :icon="['fas', 'user-secret']"
                class="icon alt"
              />
            </button>
            <button
              v-if="row.calendarInitialized"
              v-b-tooltip.hover.top="'View Availability'"
              type="button"
              class="fa-btn"
              title="View Availability"
              @click.left.exact="viewAvailability(row)"
              @click.left.alt.exact="viewAvailability(row, 'agenda')"
            >
              <font-awesome-icon :icon="['fas', 'calendar']" class="icon alt" />
            </button>

            <button
              v-b-tooltip.hover.top="'Send Message'"
              type="button"
              class="fa-btn"
              title="Send Message"
              @click="sendMessage({ counselor: row })"
            >
              <font-awesome-icon :icon="['fas', 'envelope']" class="icon alt" />
            </button>

            <button
              v-b-tooltip.hover.top="'View Counselor Details'"
              type="button"
              class="fa-btn"
              title="View Counselor Details"
              @click="viewCounselor(row)"
            >
              <font-awesome-icon :icon="['fas', 'file-alt']" class="icon alt" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="border-top text-center">
      <div v-if="canLoadMore" class="mt-3">
        <button class="btn btn-primary" @click="loadMoreCounselors()">Load More Results</button>
      </div>

      <div v-if="!canLoadMore" class="mt-3">
        <p><font-awesome-icon :icon="['fas', 'check-circle']" class="icon alt" /> All Results Loaded</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResponsiveTable',

  props: {
    counselors: {
      type: Array,
      required: true
    },

    columnSet: {
      type: String,
      required: true
    },

    sortedColumn: {
      type: String,
      required: true
    },
    sortedAsc: {
      type: Boolean,
      required: true
    },
    onSort: {
      type: Function,
      required: true
    },

    sendMessage: {
      type: Function,
      required: true
    },
    viewCounselor: {
      type: Function,
      required: true
    },
    viewAvailability: {
      type: Function,
      required: true
    },
    canLoadMore: {
      type: Boolean,
      required: true
    },
    loadMoreCounselors: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      columnSets: {
        overview: {
          columns: [
            {
              id: 'last_name',
              display_label: 'Counselor Name',
              sortTokens: ['GetCounselorAccountsByLastNameAsc', 'GetCounselorAccountsByLastNameDesc']
            },
            {
              id: 'email',
              display_label: 'Email',
              sortTokens: ['GetCounselorAccountsByEmailAsc', 'GetCounselorAccountsByEmailDesc']
            },
            {
              id: 'registered_in_states_short_names',
              display_label: 'Registered In',
              sortTokens: [null, null]
            },
            {
              id: 'verified',
              display_label: 'Verified',
              sortTokens: ['GetCounselorAccountsByVerifiedAsc', 'GetCounselorAccountsByVerifiedDesc']
            },
            {
              id: 'active',
              display_label: 'Active',
              sortTokens: ['GetCounselorAccountsByIsActiveAsc', 'GetCounselorAccountsByIsActiveDesc']
            },
            {
              id: 'has_set_working_hours',
              display_label: 'Working Hours Set',
              sortTokens: ['GetCounselorAccountsByHasSetWorkingHoursAsc', 'GetCounselorAccountsByHasSetWorkingHoursDesc']
            },
            {
              id: 'date_joined',
              display_label: 'Date Joined',
              sortTokens: ['GetCounselorAccountsByDateJoinedAsc', 'GetCounselorAccountsByDateJoinedDesc']
            },
            {
              id: 'last_login',
              display_label: 'Last Login',
              sortTokens: ['GetCounselorAccountsByLastLoginAsc', 'GetCounselorAccountsByLastLoginDesc']
            }
          ]
        },
        appointments: {
          columns: [
            {
              id: 'last_name',
              display_label: 'Counselor Name',
              sortTokens: ['GetCounselorAccountsByLastNameAsc', 'GetCounselorAccountsByLastNameDesc']
            },
            {
              id: 'pending_requests',
              display_label: 'Pending',
              sortTokens: ['GetCounselorAccountsByPendingRequestsAsc', 'GetCounselorAccountsByPendingRequestsDesc']
            },
            {
              id: 'approved_requests',
              display_label: 'Approved',
              sortTokens: ['GetCounselorAccountsByApprovedRequestsAsc', 'GetCounselorAccountsByApprovedRequestsDesc']
            },
            {
              id: 'denied_requests',
              display_label: 'Declined',
              sortTokens: ['GetCounselorAccountsByDeclinedRequestsAsc', 'GetCounselorAccountsByDeclinedRequestsDesc']
            },
            {
              id: 'canceled_requests',
              display_label: 'Canceled',
              sortTokens: ['GetCounselorAccountsByCanceledRequestsAsc', 'GetCounselorAccountsByCanceledRequestsDesc']
            },
            {
              id: 'expired_requests',
              display_label: 'Expired',
              sortTokens: ['GetCounselorAccountsByExpiredRequestsAsc', 'GetCounselorAccountsByExpiredRequestsDesc']
            },
            {
              id: 'canceled_appointments',
              display_label: 'Canceled',
              sortTokens: ['GetCounselorAccountsByCanceledSessionsAsc', 'GetCounselorAccountsByCanceledSessionsDesc']
            },
            {
              id: 'canceled_by_counselor_appointments',
              display_label: 'Canceled (by Counselor)',
              sortTokens: ['GetCounselorAccountsByCanceledByCounselorSessionsAsc', 'GetCounselorAccountsByCanceledByCounselorSessionsDesc']
            }
          ]
        }
      }
    };
  },
};
</script>

<style lang="scss" scoped>
.overflow-scroll-table {
  max-width: 100%;
  overflow-x: auto;
}

.responsive-table {
  @include border-radius($border-radius);

  width: 100%;
  border: none;

  thead {
    background: none;
    color: white;

    th {
      position: relative;
      padding: 0.75rem;
      padding-right: $gutter;
      border-bottom: 2px solid rgba(255, 255, 255, 0.25);
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;

      i,
      svg {
        position: absolute;
        top: 17px;
        right: 10px;
      }

      .fa-sort {
        z-index: 1;
        opacity: 0.2;
      }

      span {
        .fa-sort-up {
          z-index: 2;
          opacity: 0;
        }

        .fa-sort-down {
          z-index: 3;
          opacity: 0;
        }

        &.active-down {
          .fa-sort-down {
            opacity: 1;
          }
        }

        &.active-up {
          .fa-sort-up {
            opacity: 1;
          }
        }
      }

      &:hover {
        .fa-sort {
          opacity: 0.3;
        }

        span {
          .fa-sort-down {
            opacity: 1;
          }

          &.active-down {
            .fa-sort-down {
              opacity: 1;
            }

            .fa-sort-up {
              opacity: 0;
            }
          }

          &.active-up {
            .fa-sort-up {
              opacity: 1;
            }

            .fa-sort-down {
              opacity: 0;
            }
          }
        }
      }
    }
  }

  tbody {
    tr {
      td {
        padding: 0.75rem;
        color: rgba(white, 0.87);
        border-top: 1px solid rgba(255, 255, 255, 0.25);

        a {
          color: darken($highlight-color, 5%);
        }
      }
    }
  }

  .actions {
    text-align: right;
  }

  @media (max-width: $sm-max) {
    display: block;
    border: none;

    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    tbody {
      tr {
        background: $dark-blue;
        margin-bottom: 60px;

        td {
          padding: 0.75rem;
          text-align: right;
          border-bottom: none;
          border-top: 1px solid rgba(255, 255, 255, 0.25);

          &:last-of-type {
            border-bottom: none;
          }
        }
      }
    }

    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr {
      @include border-radius($border-radius);

      margin: 0 0 1rem 0;
      background: white;
    }

    td {
      position: relative;
      padding-left: 50%;
      border: none;
      border-bottom: $secondary-border;

      label {
        position: absolute;
        top: 12.5px;
        left: 15px;
        width: 45%;
        padding-right: 10px;
        font-weight: bold;
        white-space: nowrap;
        text-align: left;
      }
    }

    .btn-ghost {
      border-color: $primary-color;
      background: $primary-color;
      color: $btn-color;
      height: 45px;

      &:hover,
      &:focus {
        border-color: darken($primary-color, 5%);
        background-color: darken($primary-color, 5%);
        color: $btn-color;
      }
    }
  }

  .icons {
    white-space: nowrap;
    color: $green;
    text-align: right;

    .btn {
      margin-top: 3px;

      @media (min-width: $lg-min) {
        margin-top: 0;
        margin-left: 3px;
      }
    }
  }
}

.fa-btn {
  background: none;
  color: white;
  border: none;
  box-shadow: none;
}

</style>
